module.exports = __webpack_public_path__ + "img/logo_ocu.027149f9.png";